import {
  BooleanInput,
  maxLength,
  minValue,
  NumberInput,
  ReferenceInput,
  required,
  SelectInput,
  TextInput,
  useSimpleFormIteratorItem,
} from "react-admin";
import { Grid } from "@mui/material";
import { useWatch } from "react-hook-form";
import { administrationRequests } from "api/administrationApi";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import EmployeeInput from "server/components/Fields/EmployeeInput";

const InternshipFields = ({ watchPrefix }) => {
  const isVoluntary = useWatch({ name: `${watchPrefix}.isVoluntary` });
  const startDate = useWatch({ name: `${watchPrefix}.startDate` });
  const employeeId = useWatch({ name: `${watchPrefix}.employeeId` });
  const externalMentorName = useWatch({ name: `${watchPrefix}.externalMentorName` });

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          label="Име на стаж"
          source="name"
          fullWidth
          validate={[required(), maxLength(100)]}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <CustomDateInput
          label="Начало на стаж"
          source="startDate"
          validate={required()}
          required
          noTime
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <CustomDateInput
          label="Край на стаж"
          source="endDate"
          validate={required()}
          minDate={startDate || undefined}
          required
          noTime
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="hospitalBuildingId"
          reference={administrationRequests.getBuildingsSelect()}
        >
          <SelectInput
            label="Болница"
            fullWidth
            validate={required()}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <BooleanInput
          label="Доброволен стаж"
          source="isVoluntary"
          defaultValue={false}
          sx={{ width: "fit-content" }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <NumberInput
          label="Кредити"
          source="credits"
          fullWidth
          min={1}
          validate={isVoluntary ? minValue(1) : [required(), minValue(1)]}
          onWheel={e => e.target.blur()}
        />
      </Grid>
      {/* Mentor is a XOR - a lecturer from the nomenclature or free text, never both. Both empty is allowed. */}
      <Grid
        item
        xs={12}
        md={6}
      >
        <EmployeeInput
          source="employeeId"
          label="Ментор (преподавател)"
          fullWidth
          disabled={Boolean(externalMentorName?.trim())}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          label="Ментор (външен)"
          source="externalMentorName"
          fullWidth
          disabled={Boolean(employeeId)}
          validate={maxLength(100)}
        />
      </Grid>
    </Grid>
  );
};

export const InternshipIteratorItem = () => {
  const { index } = useSimpleFormIteratorItem();

  return <InternshipFields watchPrefix={`internships.${index}`} />;
};

export default InternshipFields;
